import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const scaffolderTasksPlugin = createPlugin({
  id: 'scaffolder-tasks',
  routes: {
    root: rootRouteRef,
  },
});

export const ScaffolderTasksPage = scaffolderTasksPlugin.provide(
  createRoutableExtension({
    name: 'ScaffolderTasksPage',
    component: () =>
      import('./components/ScaffolderTasksPage').then(
        m => m.ScaffolderTasksPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
